define( 'views/fields/preview/label',[], function() {
	var view = Marionette.ItemView.extend({
		tagName: 'div',
		template: '#tmpl-nf-field-label',

		initialize: function( data ) {
			// this.$el = jQuery( data.itemView.el ).find( '.nf-realistic-field--label' );
		},

		onRender: function() {
			// ...
			// console.log( jQuery( this.$el ) );
		},
        
		templateHelpers: function () {
	    	return {
	    		renderLabelClasses: function() {
                    // ...
                },
				maybeFilterHTML: function()  {
					return typeof nfAdmin.filter_esc_status !== "undefined" ? nfAdmin.filter_esc_status : "false";
				},
                maybeRenderHelp: function() {
                    // ...
                }
            }
        }

	});

	return view;
} );
